import React from 'react';
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl';
import * as mobxReact from 'mobx-react';
import classNames from 'classnames';
import { CommonPopupBodyFooterLayout } from '../../../../../../global/common-popup/common-popup-body-footer-layout';
import { RegistrationFormHeader } from '../registration-form-header';
import { DefaultCloseSubWindowButton } from '../../../../../../global/sub-window/common/common-close-sub-window-buttons';
import DefaultButton from '../../../../../../global/default-button/default-button';
import { CustomFieldView } from '../custom-field/custom-field.presentation';
import RegistrationFormVM from './form-registration-form.viewmodel';
import '../registration-form.scss';
import { APPLY_AND_CLOSE_TEXT, APPLY_TEXT, CANCEL_TEXT, loadingText } from '../../../../../../../constants/common-labels.constants';

interface IWebsiteRegistrationFormPresentation {
  vm: RegistrationFormVM;
  intl: IntlShape;
}

const FormRegistrationFormView = injectIntl(mobxReact.observer(({ vm, intl }: IWebsiteRegistrationFormPresentation) => {

  const validationCustomFieldError = vm.isFormApplied && !vm.customFieldView.checkValidity();
  if (vm.isLoading) {
      return <CommonPopupBodyFooterLayout
          body={
              <div className='oe-form meeting-form'>
                  { loadingText() }
              </div>
          }
      />;
  }
  return (
    <CommonPopupBodyFooterLayout
      className={'hidden-scroll'}
      body={
        <>
          <RegistrationFormHeader
            options={vm.customFieldView.triageAnswerOptions}
            selectedOption={vm.customFieldView.selectedTriageAnswerOption}
            setSelectedOption={vm.customFieldView.selectTriageAnswerOption}
            openRegistrationFormPreview={vm.openRegistrationFormPreview}
            validationCustomFieldError={validationCustomFieldError}
            validationGeneralFormError={false}
            isNewFormFieldOpen={vm.customFieldView.isAddFormOpen}
          />
          <div className={classNames('website-custom-registration-form',
            {
              'website-custom-registration-error-block ': !!validationCustomFieldError,
            })
          }
          >
            <CustomFieldView vm={vm.customFieldView} />
          </div>
        </>
      }
      footer={
        <>
          {vm.isSaving && (
            <span className='oe-popup-layout__footer-status-area'>
              <FormattedMessage
                id='oe.customFields.dataIsBeingSaved'
                description='Preloader message text'
                defaultMessage='Data is being saved, please wait{suffix}'
                values={{
                  suffix: '...'
                }}
              />

            </span>
          )}
          <div className='buttons-block buttons-block--from-right'>
            <DefaultCloseSubWindowButton
              text={intl.formatMessage(APPLY_AND_CLOSE_TEXT)}
              modifier={['fat', 'confirm-safe']}
              onClick={vm.applyRegistrationForm}
              disabled={vm.isSaving}
            />
            <DefaultButton
              text={intl.formatMessage(APPLY_TEXT)}
              modifier={['fat', 'confirm-safe']}
              onClick={vm.applyRegistrationForm}
              disabled={vm.isSaving}
            />
            <DefaultCloseSubWindowButton
              text={intl.formatMessage(CANCEL_TEXT)}
            />
          </div>
        </>
      }
    />
  );
}));


export { FormRegistrationFormView };
